import dayjs from "dayjs";
import { successNotifications } from "../../../utils/handleNotifications";

const S3_INVOICE_PREFIX = "https://asc360.s3.amazonaws.com/";

export const PAYMENTS_ENDPOINT = "issuance/payments-list/";
export const PAYMENTS_STATS_ENDPOINT = "issuance/payments-stats/";

export const PAYMENTS_SWR_CONFIG = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  revalidateIfStale: false,
  shouldRetryOnError: false,
  keepPreviousData: true,
  dedupingInterval: 60000,
};

export const STATUS_OPTIONS = [
  { value: "", label: "All Status" },
  { value: "SUCCESS", label: "Success" },
  { value: "pending", label: "Pending" },
  { value: "FAILED", label: "Failed" },
  { value: "CANCEL", label: "Cancel" },
  { value: "REFUND", label: "Refund" },
];

export const GATEWAY_OPTIONS = [
  { value: "", label: "All Gateways" },
  ...[
    "ASC360 WALLET", "BANK TRANSFER", "BIR WALLET", "Cash", "CCAvenue",
    "HBL", "NABIL_BANK", "Net Banking", "Online", "PHONE_PE", "QR",
    "RAZOR_PAY", "UPI",
  ].map((value) => ({ value, label: value })),
];

export const MANUAL_PAYMENT_OPTIONS = [
  { value: "", label: "Manual Payment" },
  { value: "true", label: "Yes" },
  { value: "false", label: "No" },
];

export const RETRY_PAYMENT_OPTIONS = [
  { value: "", label: "Retry Payment" },
  { value: "true", label: "Yes" },
  { value: "false", label: "No" },
];

export const COVER_TYPE_OPTIONS = [
  { value: "", label: "All Cover Types" },
  { value: "Domestic", label: "Domestic" },
  { value: "International", label: "International" },
];

export const PURCHASE_METHOD_OPTIONS = [
  { value: "", label: "All Purchase Methods" },
  { value: "online", label: "Online" },
  { value: "LINK", label: "Link" },
  { value: "off", label: "Off" },
];

export const PROMOCODE_OPTIONS = [
  { value: "", label: "Promocode" },
  { value: "yes", label: "With Promocode" },
  { value: "no", label: "Without Promocode" },
];

export const INITIAL_PAYMENT_FILTERS = {
  status: "", gateway: "", currency: "", manual: "", retry: "",
  coverType: "", purchaseMethod: "", promocode: "",
  updatedRange: [null, null],
};

const CURRENCY_SYMBOLS = { INR: "₹", NPR: "NRs", USD: "$" };

export const currencyOptions = (currencies = []) => [
  { value: "", label: "All Currencies" },
  ...currencies.map((code) => ({ value: code, label: code })),
];

export const formatCurrencyAmount = (currency, amount) => {
  const symbol = CURRENCY_SYMBOLS[currency] ?? `${currency} `;
  return `${symbol}${(Number(amount) || 0).toLocaleString("en-IN")}`;
};

const fmtDate = (date) => dayjs(date).format("YYYY-MM-DD");

export const buildPaymentFilterQuery = (f) => {
  const p = new URLSearchParams();
  if (f.status) p.set("status", f.status);
  if (f.gateway) p.set("gateway", f.gateway);
  if (f.currency) p.set("currency", f.currency);
  if (f.manual) p.set("manual_payment", f.manual);
  if (f.retry) p.set("retry_payment", f.retry);
  if (f.coverType) p.set("cover_type", f.coverType);
  if (f.purchaseMethod) p.set("purchase_method", f.purchaseMethod);
  if (f.promocode) p.set("has_promocode", f.promocode);
  if (f.updatedRange?.[0]) p.set("updated_from", fmtDate(f.updatedRange[0]));
  if (f.updatedRange?.[1]) p.set("updated_to", fmtDate(f.updatedRange[1]));
  return p.toString();
};

export const withSearchQuery = (query, search) => {
  const p = new URLSearchParams(query);
  const term = search?.trim();
  if (term) p.set("search", term);
  return p.toString();
};

export const withUserEmailQuery = (query, email) => {
  if (!email) return query;
  const p = new URLSearchParams(query);
  p.set("user_email", email);
  return p.toString();
};

export const downloadPaymentInvoice = (row) => {
  try {
    const downloadUrl = row?.invoice_path;
    if (!downloadUrl?.startsWith(S3_INVOICE_PREFIX)) {
      successNotifications("Download URL is not available.");
      return;
    }
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.target = "_blank";
    link.rel = "noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    successNotifications("Error downloading document:", error);
  }
};
